import React from 'react';

import {ProcessTaskStatusType} from 'graphql-client/__generated/graphqlGlobalTypes';
import StatusSummaryDisplay from 'processes/status/StatusSummaryDisplay';

interface ProcessNodeStatusCountDisplayProps {
  statusCounts: Array<{
    statusType: ProcessTaskStatusType;
    count: number;
    label?: string;
  }>;
}

export default function ProcessNodeStatusCountDisplay(
  props: ProcessNodeStatusCountDisplayProps
): JSX.Element | null {
  const hasStatusCounts = props.statusCounts != null && props.statusCounts.length > 0;
  return hasStatusCounts ? (
    <div>
      <StatusSummaryDisplay statusCounts={props.statusCounts} />
    </div>
  ) : null;
}
